import moment from "moment";
import { List, Record, fromJS } from "immutable";

const defaults = {
    _id: undefined,
    created_on: undefined,
    modified_on: undefined,
    fields: List,
    brand_schema: undefined,
};

interface IField {
    _id: string;
    brand_key: string;
    master_key: string;
    get: (key: string) => any;
}

export class BrandSchemaMapRecord extends Record(defaults) {
    declare _id: string;
    declare created_on: moment.Moment;
    declare modified_on: moment.Moment;
    declare fields: List<IField>;
    declare brand_schema: string;

    constructor(args: any = {}) {
        super({
            ...args,
            created_on: moment.utc(args.created_on),
            fields: fromJS(args.fields),
            modified_on: moment.utc(args.modified_on),
        });
    }
}
